export const ConvertDate = (date, format) => {
    date = new Date(date);
    let result;
    if (format === 'dd/mm/yyyy') {
        result = (date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`) + "/" + (parseInt(date.getMonth() + 1) >= 10 ? parseInt(date.getMonth() + 1) : `0${parseInt(date.getMonth() + 1)}`) + "/" + date.getFullYear();
    } else if (format === 'yyyy-mm-dd') {
        result = date.getFullYear() + "-" + (parseInt(date.getMonth() + 1) >= 10 ? parseInt(date.getMonth() + 1) : `0${parseInt(date.getMonth() + 1)}`) + "-" + (date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`);
    }
    return result;
}